import { FC } from "react"
import { TokenInfo } from "../../../utils/models/TokenInfo"
import { OpacityButton } from "../../button/OpacityButton"
import { TokenCount } from "../../TokenCount"
import { TokenName } from "../../TokenName"
import { Dropdown, DropdownItem } from "../Dropdown"
import { navbarButtonPresetStyle } from "../navbarButtonPresetStyle"

export interface BalanceButtonProps {
  className?: string
  availableTokens: TokenInfo[]
  balance: number
  selectedToken: TokenInfo
  onSelectToken?: (token: TokenInfo) => void
  onClick?: () => void
}

export const BalanceButton: FC<BalanceButtonProps> = props => {
  return (
    <Dropdown
      trigger={
        <OpacityButton {...navbarButtonPresetStyle} onClick={props.onClick}>
          <TokenCount token={props.selectedToken} count={props.balance} />{" "}
          <TokenName className={"ml-1"} token={props.selectedToken} />
        </OpacityButton>
      }
    >
      {props.availableTokens.map(t => (
        <DropdownItem key={t.name} onClick={() => props.onSelectToken?.(t)}>
          <TokenName token={t} />
        </DropdownItem>
      ))}
    </Dropdown>
  )
}
